import React, { useRef } from 'react';
import PackageCard from './PackageCard';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const CircularPackageSlider = ({ packages, title }) => {
  const scrollRef = useRef(null);

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = 320; // width of card + gap
      const newScrollLeft = scrollRef.current.scrollLeft + (direction === 'left' ? -scrollAmount : scrollAmount);
      scrollRef.current.scrollTo({
        left: newScrollLeft,
        behavior: 'smooth'
      });
    }
  };

  return (
    <div className="relative">
      {title && (
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900">
          {title}
        </h2>
      )}

      <div className="relative group">
        {/* Left Arrow */}
        <Button
          onClick={() => scroll('left')}
          className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-gray-100 text-gray-900 shadow-lg rounded-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          size="icon"
        >
          <ChevronLeft size={24} />
        </Button>

        {/* Scrollable Container */}
        <div 
          ref={scrollRef}
          className="flex gap-6 overflow-x-auto scrollbar-hide scroll-smooth pb-4"
          style={{ 
            scrollbarWidth: 'none',
            msOverflowStyle: 'none'
          }}
        >
          {packages.map((pkg) => (
            <PackageCard key={pkg.id} package={pkg} />
          ))}
        </div>

        {/* Right Arrow */}
        <Button
          onClick={() => scroll('right')}
          className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-gray-100 text-gray-900 shadow-lg rounded-full p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300"
          size="icon"
        >
          <ChevronRight size={24} />
        </Button>
      </div>

      <style jsx>{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
      `}</style>
    </div>
  );
};

export default CircularPackageSlider;